import axios from 'axios'
import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
// const root = "https://stuapi.kidcastle.cn"
const url = {
  getHourMedia: `${root}/Hour/getHourMedia`,
  getHourMediaOne: `${root}/Hour/getHourMediaOne`,
  AddKCTVGold: `${root}/Hour/AddKCTVGold`,
  SubmitTask: `${root}/Stutask/SubmitTask`,
}
const classStore = {
  getHourMedia(params: any) {
    return axios.get(url.getHourMedia, { params })
  },
  getHourMediaOne(params: any) {
    return axios.get(url.getHourMediaOne, { params })
  },
  AddKCTVGold(params: any) {
    return axios.post(url.AddKCTVGold, qs.stringify(params))
  },
  SubmitTask(params: any) {
    return axios.post(url.SubmitTask, qs.stringify(params))
  },
}

export default classStore;